import { useMutation } from 'react-query';
import spedFilesServices from './sped-files.services';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { QUERY_SPED_DOCUMENT_DETAIL } from '../sped-documents/sped-documents.hooks';
import { useReportGenerate } from '@/hooks';
import { SpedDocument } from '../sped-documents/sped-documents.types';
import { AxiosError } from 'axios';

export function useSpedFileSolicitation() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: spedFilesServices.solicitation,
    onSuccess(_, id) {
      notification.success({
        message: 'Geração do arquivo SPED iniciado',
      });
      queryChanel({ invalidateQueries: [[QUERY_SPED_DOCUMENT_DETAIL, id]] });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}

export function useSpedFileDownload(spedDocument?: SpedDocument) {
  const queryChanel = useQueryChanel();
  const report = useReportGenerate();

  return useMutation({
    mutationFn: spedFilesServices.download,
    onSuccess(result, id) {
      notification.success({
        message: 'Arquivo gerado com sucesso',
      });
      queryChanel({ invalidateQueries: [[QUERY_SPED_DOCUMENT_DETAIL, id]] });

      report.downloadFile({
        result,
        fileName: `sped-document-file-${spedDocument?.assessmentMonth}-${spedDocument?.assessmentYear}.tx2`,
      });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}

export function useSpedFileConsult() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: spedFilesServices.consult,
    onSuccess(_, id) {
      notification.success({
        message: 'Consulta do arquivo executado',
      });
      queryChanel({ invalidateQueries: [[QUERY_SPED_DOCUMENT_DETAIL, id]] });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}
